const t = () => ({ sizes: {
  small: {
    textVariant: "cta3",
    underlineHeight: 1.5,
    underlineOffset: 5
  },
  regular: {
    textVariant: "cta2",
    underlineHeight: 1.5,
    underlineOffset: 5
  },
  medium: {
    textVariant: "cta1",
    underlineHeight: 2,
    underlineOffset: 4
  }
} });
export {
  t as default
};
//# sourceMappingURL=text-button.js.map
